<div class="modal fade" [ngClass]="'modal-drawer-' + position" [id]="modalId" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">

      <div class="modal-header">
        <div class="header-text">
          <span class="eyebrow" *ngIf="eyebrow">{{ eyebrow }}</span>
          <h1 class="modal-title fs-5">{{ Modaltitle }}</h1>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="singlefield" *ngIf="Singlefields">
          <label class="w-100">{{ header }}</label>
          <ng-container *ngIf="singleFieldType === 'bitcase'; else plainSingleInput">
            <div class="bitcase-simple-wrap">
              <input type="text" class="form-control df-input mb-2 font-monospace fw-semibold"
                [value]="singleFieldCalculatedTotal || inputValue || '0'" readonly tabindex="-1" />
              <div class="pt-1" *ngIf="!hideCheckboxes">
                <div class="d-flex align-items-center gap-3 flex-wrap">
                  <label
                    *ngFor="let bit of (displayedSingleFieldBits?.length ? displayedSingleFieldBits : singleFieldBits)"
                    class="form-check form-check-inline m-0 d-inline-flex flex-column align-items-center gap-1 cursor-pointer"
                    [title]="bit.label ? (bit.label + (bit.value && bit.label !== bit.value ? ' (' + bit.value + ')' : '')) : ('Value: ' + bit.value)">
                    <input type="checkbox" class="form-check-input bitcase-chk" [(ngModel)]="bit.checked"
                      (ngModelChange)="onSingleBitToggle(bit)" />
                    <span class="small text-muted" style="font-size: 11px;">{{ bit.label }}</span>
                  </label>
                </div>
                <div class="text-secondary small mt-1 fw-semibold" *ngIf="bitLabelsStr">
                  {{ bitLabelsStr }}
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #plainSingleInput>
            <input type="text" [(ngModel)]="inputValue" class="w-100 form-control df-input">
          </ng-template>
        </div>

        <div class="row gx-3" *ngIf="Multiplefields">
          <ng-container *ngFor="let items of FormArray; let i = index">

            <div [class]="items.class +'df-section-title'" *ngIf="items.sectionTitle">
              <i class="bi bi-collection"></i> {{ items.sectionTitle }}
            </div>

            <div class='{{items.class}} df-field-group' *ngIf="items.view !== false">
              <label>
                <i class="{{ items.icon }}" *ngIf="items.icon"></i>
                {{ items.placeholder }}
                <span class="text-danger"
                  *ngIf="items.required && !items.readonly && !items.skipRequiredValidation">*</span>
              </label>

              <ng-container *ngIf="items.type === 'bitcase'; else nonBitcaseInput">
                <div class="bitcase-simple-wrap">
                  <input type="text" class="form-control df-input mb-2 font-monospace fw-semibold"
                    [value]="items.calculatedTotal ?? items.value ?? '0'" readonly tabindex="-1" />
                  <div class="pt-1" *ngIf="!items.hideCheckboxes">
                    <div class="d-flex align-items-center gap-3 flex-wrap">
                      <label *ngFor="let bit of (items.displayedBits || items.bits)"
                        class="form-check form-check-inline m-0 d-inline-flex flex-column align-items-center gap-1 cursor-pointer"
                        [title]="bit.label ? (bit.label + (bit.value && bit.label !== bit.value ? ' (' + bit.value + ')' : '')) : ('Value: ' + bit.value)">
                        <input type="checkbox" class="form-check-input bitcase-chk" [(ngModel)]="bit.checked"
                          [disabled]="items.readonly" (ngModelChange)="onBitToggle(items, bit)" />
                        <span class="small text-muted" style="font-size: 11px;">{{ bit.label }}</span>
                      </label>
                    </div>
                    <div class="text-secondary small mt-1 fw-semibold" *ngIf="items.bitLabelsStr || items.subLabel">
                      {{ items.bitLabelsStr || items.subLabel }}
                    </div>
                  </div>
                </div>
                <div class="df-validation-msg"
                  *ngIf="submitted && items.required && !items.readonly && !items.skipRequiredValidation && (items.value === undefined || items.value === null)">
                  <small class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> This field is
                    required</small>
                </div>
              </ng-container>

              <ng-template #nonBitcaseInput>
                <ng-container *ngIf="items.dropdown; else normalInput">
                  <div class="df-input-wrap">
                    <select [(ngModel)]="items.value" [compareWith]="compareSelectOptions" [disabled]="items.readonly"
                      class="{{items.class}} form-control df-input">
                      <option [ngValue]="''">-- Select {{ items.placeholder }} --</option>
                      <option *ngFor="let opt of items.options"
                        [ngValue]="opt.id !== undefined ? opt.id : (items.optionKey ? opt[items.optionKey] : opt)">
                        {{ opt.name }}
                      </option>
                    </select>
                  </div>
                  <div class="df-validation-msg"
                    *ngIf="(submitted || items.isDirty || items.touched) && items.required && !items.readonly && !items.skipRequiredValidation && (!items.value || items.value === '')">
                    <small class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> This field is
                      required</small>
                  </div>
                </ng-container>

                <ng-template #normalInput>
                  <ng-container *ngIf="items.type === 'date'; else plainInput">
                    <div class="date-range-wrapper w-100 df-input-wrap" [class.df-readonly-wrap]="items.readonly">
                      <input [readonly]="items.readonly" #fp="mwlFlatpickr"
                        class="{{items.class}} form-control df-input datepicker" type="text"
                        [placeholder]="items.monthYear ? 'Select Month' : 'Select Date'" mwlFlatpickr
                        [minDate]="getMinDate(items)" [maxDate]="getMaxDate(items)" [(ngModel)]="items.value"
                        (ngModelChange)="items.isDirty = true; updateFormattedDate(items); validateInput(items)"
                        [mode]="'single'" [dateFormat]="items.monthYear ? 'Y-m' : 'Y-m-d'" [altInput]="true"
                        [disableMobile]="true" [altFormat]="items.monthYear ? 'Y-m' : 'F j, Y'"
                        [clickOpens]="!items.readonly"
                        [class.is-invalid]="(items.regex && items.value && !items.isValid) || ((submitted || items.isDirty || items.touched) && items.required && !items.readonly && !items.skipRequiredValidation && !items.value)"
                        [class.is-valid]="items.regex && items.value && items.isValid" />
                      <img src="assets/DashboardIcon/calendar-icon.svg" class="calendar-icon" alt="Calendar Icon"
                        [style.cursor]="items.readonly ? 'not-allowed' : 'pointer'"
                        [style.opacity]="items.readonly ? '0.5' : '1'"
                        [style.pointer-events]="items.readonly ? 'none' : 'auto'"
                        (click)="openCalendar(fp, items.readonly)" />
                    </div>
                    <div class="df-validation-msg" *ngIf="items.regex && items.value && !items.isValid">
                      <small class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> {{
                        validationMessage(items)
                        }}</small>
                    </div>
                    <div class="df-validation-msg"
                      *ngIf="(submitted || items.isDirty || items.touched) && items.required && !items.readonly && !items.skipRequiredValidation && !items.value">
                      <small class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> This field is
                        required</small>
                    </div>
                  </ng-container>

                  <ng-template #plainInput>
                    <div class="df-input-wrap">
                      <input [readonly]="items.readonly" [type]="items.type" [(ngModel)]="items.value"
                        (ngModelChange)="validateInput(items)" (blur)="items.touched = true; validateInput(items)"
                        class="{{items.class}} form-control df-input"
                        [class.is-invalid]="(items.regex && items.value && !items.isValid) || ((submitted || items.isDirty || items.touched) && items.required && !items.readonly && !items.skipRequiredValidation && (!items.value || !items.value.toString().trim()))"
                        [class.is-valid]="items.value && items.isValid" />
                      <i class="bi bi-check-circle-fill df-valid-icon"
                        *ngIf="items.regex && items.value && items.isValid"></i>
                    </div>
                    <!-- Required validation message -->
                    <div class="df-validation-msg"
                      *ngIf="(submitted || items.isDirty || items.touched) && items.required && !items.readonly && !items.skipRequiredValidation && (!items.value || !items.value.toString().trim())">
                      <small class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> This field is
                        required</small>
                    </div>
                    <!-- Regex pattern error message -->
                    <div class="df-validation-msg" *ngIf="items.regex && items.value && !items.isValid">
                      <small class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> {{
                        validationMessage(items)
                        }}</small>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn Cancel btn-outline-danger w-50" data-bs-dismiss="modal">
          <i class="bi bi-x-lg"></i> {{ leftButtonTitle }}
        </button>
        <button type="button" class="btn btn-primary w-50 edit-modal-button" (click)="emitValue()">
          <i class="bi bi-check-lg"></i> Save Form
        </button>
      </div>

    </div>
  </div>
</div>